/**
 * Founder Program Banner - Urgent banner for veterinarian recruitment
 * Fetches city data dynamically from API
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Rocket, MapPin, Users } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FounderProgramBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [cityData, setCityData] = useState({
    name: "Nîmes",
    total_spots: 10,
    remaining_spots: 7
  });

  useEffect(() => {
    const fetchFeaturedCity = async () => {
      try {
        const response = await fetch(`${API_URL}/api/founder-program/cities/featured`);
        if (response.ok) {
          const data = await response.json();
          setCityData(data);
        }
      } catch (error) {
        console.debug('Using default city data for banner');
      }
    };
    fetchFeaturedCity();
  }, []);

  if (!isVisible || cityData.remaining_spots <= 0) return null;

  return (
    <div className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 text-white py-3 relative overflow-hidden">
      {/* Animated background effect */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,white_1px,transparent_1px)] bg-[length:20px_20px]"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-center sm:text-left">
          {/* Icon and Title */}
          <div className="flex items-center gap-2">
            <Rocket className="w-5 h-5 text-yellow-400 animate-pulse" />
            <span className="font-bold text-sm sm:text-base">
              Programme Clinique Fondatrice
            </span>
            <span className="flex items-center gap-1 bg-white/20 px-2 py-0.5 rounded-full text-xs sm:text-sm">
              <MapPin className="w-3 h-3" />
              {cityData.name}
            </span>
          </div>
          
          {/* Spots indicator */}
          <div className="flex items-center gap-3">
            <span className="text-sm text-blue-200">
              {cityData.total_spots} cliniques sélectionnées
            </span>
            <span className="bg-yellow-500 text-yellow-900 px-3 py-1 rounded-full text-sm font-bold flex items-center gap-1 animate-pulse">
              <Users className="w-4 h-4" />
              {cityData.remaining_spots} places restantes
            </span>
          </div>
          
          {/* CTA */}
          <Link
            to="/veterinaires"
            className="bg-white text-blue-900 px-4 py-1.5 rounded-full text-sm font-semibold hover:bg-yellow-400 transition-colors whitespace-nowrap"
            data-testid="founder-program-cta"
          >
            En savoir plus
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FounderProgramBanner;
